import {IconType, IoniconsFilled, IoniconsOutline} from '../enums';
import {ListData} from './list-data';

import {Observable} from 'rxjs';
import {ColDef} from 'ag-grid-community';
import {ColAction} from "./col-action";

export enum AttributeType {
  STRING = 'STRING',
  DATE = 'DATE',
  BOOLEAN = 'BOOLEAN',
  ASYNC = 'ASYNC',
  HTML = 'HTML'
}

export interface DetailIcon {
  type: IconType;
  key: IoniconsOutline | IoniconsFilled;
  size?: number;
  hide?: boolean;
  iconClass?: string;
  position?: 'left' | 'right';
}

export interface DetailAttribute {
  key: Observable<string>;
  value: any;
  type: AttributeType;
  keyIcon?: DetailIcon;
  valueIcon?: DetailIcon;
  cssClass?: string;
  showInAll?: boolean;
  link?: string[];
  queryParamsLink?: any;
  permissVisible?: string[];
  permissEnabled?: string[];

  valueChildren: DetailAttribute[]; // se si vuole mettere nel value una serie di link
  isClickable?: boolean; // Da usare SOLO per le modali
}

export interface DetailBody {
  attributes: DetailAttribute[],
  actions?: DetailAction[];
  actionButtons?: DetailActionButton[];
}

export interface DetailAction extends ColAction {
  separateFromAbove?: boolean;
  detailIcon?: DetailIcon;
}

export interface DetailActionButton {
  icon?: DetailIcon;
  class?: string;
  label?: Observable<string>;
  id: string;
  disabled?: boolean;
}

export interface DetailTable {
  label: Observable<string>;
  config: ListData<unknown>;
  columnDefinition: ColDef[];
}

export interface Detail {
  label: Observable<string>;
  body: DetailBody;
  separateFromAbove?: boolean;
}
